import axios from 'axios';

let platformAccountId;
const publisherPathname = window.location.pathname.match(/publisher\/(\d+)/);

if (publisherPathname) {
  platformAccountId = publisherPathname[1];
}

const csrfToken = document.querySelector('[name=csrf-token]').content
axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken

const postTrackingEvent = (data) => {
  return axios.post(`/api/internal/trackings/${platformAccountId}`, data);
}

const postAnonymousTrackingEvent = (data) => {
  return axios.post('/api/internal/trackings', data);
}

export default {
  postTrackingEvent,
  postAnonymousTrackingEvent
};
